/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MoneyWalletAOpenIcon16Solid = forwardRef('MoneyWalletAOpenIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1 4.774a2.5 2.5 0 0 1 1.674-2.36L9.004.198A1.5 1.5 0 0 1 11 1.614V4H3.5a.5.5 0 0 0 0 1h9a2.5 2.5 0 0 1 2.45 2H10.5a2.5 2.5 0 0 0 0 5H15v.5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5V4.774Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 11h-4.5a1.5 1.5 0 1 1 0-3H15v3Zm-3-1.468a.7.7 0 1 1-1.4 0 .7.7 0 0 1 1.4 0Z" })));
});
